import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import {
  setHeaderConfigsAction,
  setHeaderTitleAction
} from '../../../reactRedux/Actions/headerAction';
import { useDispatch } from 'react-redux';
import { toggleBackButtonAction } from '../../../reactRedux/Actions/sideBarAction';
import useDesktopDisplay from '../../../hooks/useDesktopDisplay';
import { toast } from 'react-toastify';
import { routes } from '../../../assets/routes';
import { useHistory } from 'react-router-dom';
import { changePasswordRequest } from './api';
import { useMutation } from '@tanstack/react-query';
import PasswordInput from '../../common/PasswordInput';
import Button from '@mui/material/Button';
import { useTranslation } from '../../../i18n/LanguageProvider';

const ChangePassword = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isDesktop = useDesktopDisplay();
  const history = useHistory();

  const [oldPass, setOldPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [newPassRepeat, setNewPassRepeat] = useState('');
  const [error, setError] = useState({ old: false, new: false, repeat: false });
  const [err, setErr] = useState(false);

  const changePasswordMutation = useMutation(changePasswordRequest, {
    onSuccess() {
      toast.success(t('changePassword.success'));
      history.push(routes.SETTINGS);
    },
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });

  let pattern = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/;

  const setHeader = (title) => dispatch(setHeaderTitleAction(title));
  const setHeaderConfigs = (configs) =>
    dispatch(setHeaderConfigsAction(configs));
  const setSideBarBackButton = (show) => dispatch(toggleBackButtonAction(show));

  useEffect(() => {
    setSideBarBackButton(true);

    return () => setSideBarBackButton(false);
  }, []);

  useEffect(() => {
    setHeader(t('settings.changePassword'));
    setHeaderConfigs({ credits: false, exit: false, back: true });
  });

  useEffect(() => {
    if (newPass !== '') {
      if (!newPass.match(pattern)) {
        setErr(true);
      } else {
        setErr(false);
      }
    }

    if (newPassRepeat !== '') {
      if (newPassRepeat.length >= newPass.length) {
        if (newPass !== newPassRepeat) {
          setError({
            ...error,
            repeat: t('changePassword.mismatch')
          });
        } else {
          setError({ ...error, repeat: false });
        }
      }
      // else if (newPassRepeat.length < newPass.length) {
      // }
    } else {
      setError({ ...error, repeat: false });
    }
  }, [newPass, newPassRepeat]);

  const onOldPassChange = (e) => setOldPass(e.target.value);
  const onNewPassChange = (e) => setNewPass(e.target.value);
  const onRepeatChange = (e) => setNewPassRepeat(e.target.value);

  const checkValidity =
    !!error.repeat ||
    !!error.new ||
    !!error.old ||
    !newPass ||
    !oldPass ||
    !newPassRepeat ||
    err;

  return (
    <div className={classNames(styles.page, styles.full)}>
      <div className={styles.section}>
        {isDesktop && (
          <div className={styles.pageHeader}>
            {t('settings.changePassword')}
          </div>
        )}
        <div className={styles.sectionBody}>
          <PasswordInput
            id={'old-password'}
            label={t('changePassword.old')}
            className={styles.input}
            value={oldPass}
            onChange={onOldPassChange}
            ltr
            error={!!error.old}
            helperText={error.old}
          />
          <PasswordInput
            id={'new-password'}
            label={t('changePassword.new')}
            className={styles.input}
            value={newPass}
            onChange={onNewPassChange}
            ltr
            error={err}
            helperText={err ? t('changePassword.invalidChars') : ''}
          />
          <PasswordInput
            id={'confirm-new-password'}
            label={t('changePassword.repeat')}
            className={styles.input}
            value={newPassRepeat}
            onChange={onRepeatChange}
            ltr
            error={!!error.repeat}
            helperText={error.repeat}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              changePasswordMutation.mutate({
                oldPassword: oldPass,
                newPassword: newPass
              })
            }
            fullWidth
            className={styles.btn}
            style={{ marginTop: 16 }}
            disabled={checkValidity}
            loading={changePasswordMutation.isLoading}
          >
            {t('common.submit')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
